/**
 * Zita brand design tokens — SINGLE SOURCE OF TRUTH for JS-consumed colors.
 *
 * MUST match the frontend Tailwind theme in `/app/frontend/src/index.css` and
 * the backend `/app/backend/brand.py` 1:1. Any consumer that cannot read CSS
 * variables (recharts stroke/fill, inline SVG marks, imperative canvas)
 * imports from here.
 *
 * Website palette (locked Feb 2026):
 *   Platform (Zita)  → Navy + Presidential Blue + Metallic Silver
 *   AI       (Ari)   → Purple + Lavender
 *   Action   (CTA)   → Orange
 *
 * Semantic status colors (success/warning/danger) exist ONLY for their
 * meaning. Never applied as brand accents.
 */

export const ZITA = {
  // Platform (Zita) — cool premium palette
  navy:        '#0D1E3D',   // Sidebar / darkest surfaces
  navyHover:   '#1A2C4C',
  blue:        '#1465F0',   // Presidential blue — links / active states
  blueSoft:    '#EAF1FE',
  silver:      '#E5E9EF',
  silverSoft:  '#F1F3F7',
  cloud:       '#F7FAFD',   // Body background
  fog:         '#FFFFFF',   // Card interior
  hairline:    '#E1E5EC',   // 1px borders

  // Text — deep navy (no harsh black)
  ink:         '#14203A',
  inkSoft:     '#3E4B66',
  inkMuted:    '#6E7A8B',

  // CTA — orange
  orange:      '#F5661C',
  orangeDeep:  '#DB5312',
  orangeSoft:  '#FEF1E8',

  // Ari (AI)
  ari:         '#6C5CF5',
  ariStrong:   '#4C3EE8',
  ariSoft:     '#EEEBFF',

  // Semantic status — meaning-bound, NEVER used as brand accents
  success:     '#059669',
  warning:     '#B45309',
  danger:      '#B03A2E',
};

/**
 * Palette for the Business Health chart series. Blue = platform,
 * Orange = revenue/growth, Purple = Ari, semantic colors for
 * growth/decline meaning.
 */
export const CHART_TOKENS = {
  signups:         ZITA.blue,       // platform blue
  revenue:         ZITA.success,    // money made = success green
  cancellations:   ZITA.warning,    // amber warning
  failedPayments:  ZITA.danger,     // red danger
  scans:           ZITA.blue,       // platform blue
  exports:         ZITA.ari,        // Ari accent
  ariChats:        ZITA.ari,        // Ari volume
  tickets:         ZITA.orange,     // CTA orange
  humanTakeover:   ZITA.success,    // team engagement

  // Chart chrome
  grid:            ZITA.hairline,
  axisText:        ZITA.inkMuted,
};

export default ZITA;
